import { QueryClient, useMutation } from "@tanstack/react-query";
import { Post, UpdatePost } from "../types/post";
import { WORKER_URL } from "../constants";


export const queryClient = new QueryClient();


const updatePost = async (updatedPost: UpdatePost) => {
    const res = await fetch(`${WORKER_URL}/posts/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedPost),
    });

    if (!res.ok) {
        throw new Error('Failed to update post');
    }

    return res.json();
};

const uploadMedias = async (files: FileList) => {
    const formData = new FormData();
    for (const file of files) {
        formData.append(file.name, file);
    }
    const uploadRes = await fetch(`${WORKER_URL}/posts/upload`, {
        method: "POST",
        body: formData
    });
    const { uploaded } = await uploadRes.json();
    return uploaded as string[];
}

const addPost = async (post: Omit<Post, "id" | "createdAt">) => {
    const res = await fetch(`${WORKER_URL}/posts/add`,
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(post),
        }
    );
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    return await res.json();
}

export function useAddPost() {
    return useMutation({
        mutationFn: addPost
    });
}

export function useUpdatePost() {
    return useMutation({
        mutationFn: updatePost,
    });
}
export function useUploadMedias() {
    return useMutation({
        mutationFn: uploadMedias
    });
}